import React, { useState } from 'react';
import { Card, Col, Row, Form, ListGroup } from 'react-bootstrap';
import './index.css';

const AdminPermission = ({ selectedRoles, setSelectedRoles }) => {
    const [activeOption, setActiveOption] = useState(null);
    
    const permissionOptions = {
        transaction: ['Deposit', 'Withdraw', 'Bank-Transfer' , 'Bank-Transfer-Request'],
        bank: ['Bank-Page-View'],
        website: ['Website-Page-View'],
        create: ['Create-User', 'Create-Introducer'],
        profile: ['User-Profile-View', 'Introducer-Profile-View'],
        report: ['All-Transaction-Report', 'My-Transaction-Report'],
        request: ['All-Transaction-Request', 'Introducer-Transaction-Request', 'Bank-Requests', 'Website-Requests'],
        // recycleBin: ['Recycle-Bin-View']
    };

    const toggleMainOption = (e, option) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveOption(activeOption === option ? null : option);
    };

    const handlePermissionChange = (permission, isChecked) => {
        if (permission === 'Dashboard-View' && !isChecked) return;

        setSelectedRoles(prev => {
            if (isChecked) {
                return [...prev, permission];
            } else {
                return prev.filter(p => p !== permission);
            }
        });
    };

    return (
        <Card className="permission-card">
            <Card.Body>
                <h5 className="permission-title">Admin Permissions</h5>
                <Row>
                    {/* First Column - Main Options */}
                    <Col md={5}>
                        <ListGroup className="permission-list">
                            {Object.keys(permissionOptions).map((option) => (
                                <ListGroup.Item
                                    key={option}
                                    action
                                    active={activeOption === option}
                                    onClick={(e) => toggleMainOption(e, option)}
                                    className="permission-item"
                                >
                                    <div className="permission-item-content">
                                        {option.charAt(0).toUpperCase() + option.slice(1).replace(/-/g, ' ')}
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Col>

                    {/* Second Column - Selected Options Panel */}
                    <Col md={7} className="selected-panel">
                        <Card className="permission-sub-card">
                            <Card.Body>
                                {activeOption && (
                                    <>
                                        <h6 className="panel-title">
                                            {activeOption.charAt(0).toUpperCase() + activeOption.slice(1).replace(/-/g, ' ')} Permissions
                                        </h6>
                                        <div className="permission-checkboxes">
                                            {permissionOptions[activeOption].map(permission => (
                                                <Form.Check
                                                    key={permission}
                                                    type="checkbox"
                                                    id={`perm-${permission}`}
                                                    label={permission.replace(/-/g, ' ')}
                                                    checked={selectedRoles.includes(permission)}
                                                    onChange={(e) => handlePermissionChange(permission, e.target.checked)}
                                                    className="permission-checkbox"
                                                />
                                            ))}
                                        </div>
                                    </>
                                )}
                                {!activeOption && (
                                    <div className="text-muted text-center py-3">
                                        Select A Permission Category From The Left
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default AdminPermission;